import { useVueI18n } from '../locales'
const t = useVueI18n()
export const backgroundPositionOptions = [
  {
    value: 'center center',
    get label() { return t('proposals.center') },
  },
  {
    value: 'top center',
    get label() { return t('proposals.topCenter') },
  },
  {
    value: 'top left',
    get label() { return t('proposals.topLeft') },
  },
  {
    value: 'top right',
    get label() { return t('proposals.topRight') },
  },
  {
    value: 'bottom right',
    get label() { return t('proposals.bottomRight') },
  },
  {
    value: 'bottom left',
    get label() { return t('proposals.bottomLeft') },
  },
  {
    value: 'bottom center',
    get label() { return t('proposals.bottomCenter') },
  },
]

export const backgroundSizeOptions = [
  {
    value: 'auto',
    get label() { return t('proposals.auto') },
  },
  {
    value: 'contain',
    get label() { return t('proposals.fitToSize') },
  },
  {
    value: 'cover',
    get label() { return t('proposals.fillPage') },
  },
]

export const backgroundRepeatOptions = [
  {
    value: 'no-repeat',
    get label() { return t('proposals.noRepeat') },
  },
  {
    value: 'repeat',
    get label() { return t('proposals.repeat') },
  },
  {
    value: 'repeat-x',
    get label() { return t('proposals.repeatX') },
  },
  {
    value: 'repeat-y',
    get label() { return t('proposals.repeatY') },
  },
]
